import React from 'react';
import { Link } from 'react-router-dom';
import PropType from 'prop-types';
import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';
import axios from 'axios';
import settings from '../../settings.json';

const apiHost = process.env.REACT_APP_API_HOST;
const apiProto = process.env.REACT_APP_API_PROTOCOL;

const fetchOptions = (inputValue) => {
  const url = `${apiProto}://${apiHost}/nuclei/gene_list?filter=${inputValue}`;
  return axios.get(url).then((response) => {
    const options = response.data.map(item => ({ value: item.value, label: item.label }));
    return options;
  });
};

class BarPlot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      geneList: '',
      error: null,
    };
  }

  handleSubmit = () => {
    const { match, cellPopulation } = this.props;
    const { geneList } = this.state;
    this.setState({ error: null });

    // validation here??
    if (geneList.length === 0) {
      this.setState({ error: 'You must select a set of genes' });
      return;
    }
    if (cellPopulation.get('chosen').size === 0) {
      this.setState({ error: 'You must select a cell population' });
      return;
    }

    // grab all values from the form state.
    const genes = this.state.geneList.map(entry => entry.value);

    const geneSearchPayload = {
      source: 'nuclei',
      filters: genes,
    };

    const wildcardSearch = `${apiProto}://${apiHost}/gene_search`;

    axios.post(wildcardSearch, geneSearchPayload).then((response) => {
      let ord = cellPopulation.get('chosen');

      if (cellPopulation.get('order') === 'alpha') {
        ord = ord.sort();
      } else if (cellPopulation.get('order') === 'grouped') {
        const fullList = settings.regionList;
        ord = fullList.filter(region => ord.has(region));
      }
      // else we leave it as it was selected by the user.


      const payload = {
        type: 'barplot',
        category: 'nuclei',
        genes: response.data,
        ord,
      };

      // submit values to the backend storage and retrieve the uuid
      const saveSearch = `${apiProto}://${apiHost}/search`;
      axios.post(saveSearch, payload).then((searchRes) => {
        // redirect to the results page which will load in the image and parameters.
        const redirect = `${match.path}/${searchRes.data}`;
        this.props.history.push(redirect);
      });
    });
  }

  render() {
    const { error } = this.state;
    return (
      <div>
        { error && (<div className="alert alert-danger" role="alert">{error}</div>)}
        <div className="form-group">
          <label htmlFor="geneList">Genes <Link to="/about#geneselection">?</Link></label>
          <AsyncCreatableSelect
            isMulti
            placeholder="Start typing to load gene options"
            noOptionsMessage={() => "No options, please use a less specific filter string. Still can't find your gene of interest? Please see our methods section, by clicking on the '?' next to this search box."}
            loadOptions={fetchOptions}
            formatCreateLabel={input => `search for ${input}`}
            name="geneList"
            value={this.state.geneList}
            onChange={value => this.setState({ geneList: value })}
          />
        </div>
        <button className="btn btn-primary" onClick={this.handleSubmit}>Submit</button>
      </div>
    );
  }
}

BarPlot.propTypes = {
  match: PropType.object.isRequired,
  history: PropType.object.isRequired,
  cellPopulation: PropType.object.isRequired,
};

export default BarPlot;



// WEBPACK FOOTER //
// ./src/components/Nuclei/BarPlot.jsx